<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :loading="loading"
    :search-input.sync="query"
    :label="label"
    :hint="hint"
    persistent-hint
    item-text="label"
    item-value="id"
    :no-data-text="noDataText"
    :no-filter="true"
    clearable
    return-object
    @change="$emit('input', $event)"
  ></v-autocomplete>
</template>

<script>
import { Grape, errorHandler } from 'aveine-toolbox'

/**
 * Selection d'un cepage par recherche sur le nom de sa variete (REDMINE-13839),
 * sur le modele de AveineRegionPicker.
 */
export default {
  name: 'AveineGrapePicker',
  props: {
    /** Le cepage choisi ({ id, label }), ou null. */
    value: { type: Object, default: null },
    label: { type: String, required: true },
    hint: { type: String, default: '' },
    APIbaseURL: String
  },
  data: () => ({
    entries: [],
    loading: false,
    query: null,
    debounce: null
  }),
  computed: {
    /** Le cepage deja choisi, injecte pour que le champ ne paraisse pas vide. */
    items () {
      const entries = this.entries.slice()
      if (this.value && !entries.some(entry => entry.id === this.value.id)) {
        entries.unshift(this.value)
      }
      return entries
    },
    noDataText () {
      return this.query && this.query.length >= 2
        ? this.$t('intranet.homeContent.featuredGrape.noGrape')
        : this.$t('intranet.homeContent.picker.typeToSearch')
    }
  },
  watch: {
    query (value) {
      if (!value || value.length < 2) return
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => this.search(value), 300)
    }
  },
  beforeDestroy () {
    clearTimeout(this.debounce)
  },
  methods: {
    async search (value) {
      this.loading = true
      try {
        // Le nom vit sur la variete, en texte simple : voir AveineWinePicker
        // pour l'echappement des jokers.
        const term = String(value).replace(/[%_\\]/g, m => '\\' + m)
        const response = await Grape.api().get(
          'grapes',
          {
            baseURL: this.APIbaseURL,
            params: {
              include: 'grape_variety',
              filter: `grape_variety.name=ilike=%${term}%`,
              'page[size]': 20
            }
          }
        )
        this.entries = (response.entities ? response.entities.grapes || [] : []).map(grape => {
          const full = Grape.query().whereId(grape.id).with('grape_variety').first() || grape
          return { id: grape.id, label: this.$options.describe(full) }
        })
      } catch (errors) {
        errorHandler(errors, this)
      } finally {
        this.loading = false
      }
    }
  },

  /** Le nom de la variete. Partage avec la liste des cepages du profil. */
  describe (grape) {
    return (grape && grape.grape_variety && grape.grape_variety.name) || ''
  }
}
</script>
